import { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: 'list',
    name: 'control-panel.downloads.list',
    component: () => import('@/views/control-panel/projects/project/exports/List.vue'),
  },
  {
    path: 'new',
    name: 'control-panel.downloads.create',
    component: () => import('@/views/control-panel/projects/project/exports/export/Create.vue'),
  }
]

export default routes
